/**
 * Saved Search CRUD services
 */

import { axios, httpWithAuth } from '~/clients';
import {
  ANONYMOUS_SAVED_SEARCH,
  RCB_SAVED_SEARCH
} from '~/constants/endpoints';
import type { SavedSearch } from '~/contracts/common';
import BrowserCookies from '~/utilities/BrowserCookies';

export type LegacySavedSearch = {
  name: string;
  savedSearchId: number;
  url: string;
};

type SavedSearchResponse = {
  email: string;
  savedSearches?: LegacySavedSearch[];
};

/**
 * Create a saved search for NGCP Nudge.
 *
 * If a user ID is passed in, an authenticated request will be made which will
 * associate the saved search with the user's account.
 *
 * If no user ID is passed in, an anonymous request will be made which will
 * associate the saved search with the email address.
 */
export function createAnonymousSavedSearch(
  payload: {
    email: string;
    name: string;
    url: string;
    zip5: string;
  },
  controller?: AbortController
) {
  return axios.post<SavedSearchResponse>(
    ANONYMOUS_SAVED_SEARCH,
    {
      ...payload,
      isEmailCampaignActive: true,
      isSmsCampaignActive: false,
      browserCookieId: BrowserCookies.get('BrowserCookieId')
    },
    {
      signal: controller?.signal
    }
  );
}

export function readSavedSearch(query: string, controller?: AbortController) {
  return httpWithAuth.get<SavedSearch[]>(`${RCB_SAVED_SEARCH}?${query}`, {
    headers: {
      'Cache-Control': 'no-cache'
    },
    signal: controller?.signal
  });
}

export function createSavedSearchRCB(
  payload: {
    email: string;
    name: string;
    url: string;
    userId: string;
    zip5: string;
  },
  controller?: AbortController
) {
  return httpWithAuth.post<SavedSearch[]>(
    RCB_SAVED_SEARCH,
    {
      ...payload,
      isEmailCampaignActive: true,
      isSmsCampaignActive: false,
      browserCookieId: BrowserCookies.get('BrowserCookieId')
    },
    {
      signal: controller?.signal
    }
  );
}

export function deleteSavedSearchRCB(
  payload: {
    browserCookieId: string;
    email: string;
    savedSearchId: number;
    userId: string;
    zip5: string;
  },
  controller?: AbortController
) {
  return httpWithAuth.delete<SavedSearch[]>(RCB_SAVED_SEARCH, {
    data: payload,
    signal: controller?.signal
  });
}
